export const MONTHS = ["January","February","March","April","May","June","July","August","September","October","November","December"];
export const MONTHS_SHORT = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
export const CURRENCIES = ["PGK", "USD", "AUD"];
export const LOCAL_STORAGE_KEY = "png-tax-calculator-data";
export const DEFAULT_ADMINS = ["pierre.bussy@easy-skill.com"];
export const AUTHORIZED_EMAILS = []; // Managed dynamically via admin panel

export const now = new Date();
export const emptyLine = (id) => ({ id, label: "Office", days: "", rate: "", sgRate: "", rateMode: "daily" });
export const emptyAllowance = (id) => ({ id, label: "", type: "fixed_monthly", amount: "", entity: "png", currency: "" });
export const newEmployee = () => ({ id: Date.now(), name: "", matricule: "", position: "", address: "", empType: "resident", dependants: 0, project: "", currency: "PGK", splitContract: false, year: now.getFullYear(), monthlyData: {} });
